export const SUBMIT_LEADGEN_URL = "/submit";